module.exports = __webpack_public_path__ + "static/Graphik-Bold-Cy-Web-41d5511e2e835b816b64f1a6890aebe1.woff2";